import React from 'react';

import style from './Messages.css';

const MessagesComponent = ({ messages, clearMessage }) => (
  <div className={style.titlebarMessage}>
    {messages.map(m => (
      <div key={m.messageId} className={style[m.messageType]}>
        <span className={style.messageType}>{m.messageType}</span>
        <span className={style.messageText}>{m.text} </span>
        <span onClick={clearMessage} className={style.clearMessage} data-messageid={m.messageId}>
          x
        </span>
      </div>
    ))}
  </div>
);

export default MessagesComponent;
